import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { inr } from "@/lib/format";

export default function PropertyCard({ p, tall }) {
  if (p.coming_soon) {
    return (
      <div data-testid={`property-card-${p.slug}`} className={`border border-[#E2DCD0] bg-[#E5D9C5]/40 p-8 flex flex-col justify-end ${tall ? "min-h-[420px]" : "min-h-[300px]"}`}>
        <p className="eyebrow text-[#C28B5E]">{p.state}</p>
        <h3 className="text-3xl text-[#1E3B2E] mt-2">{p.city}</h3>
        <p className="text-sm text-[#6b6b6b] mt-2">Coming soon</p>
      </div>
    );
  }
  return (
    <Link to={`/hotels/${p.slug}`} data-testid={`property-card-${p.slug}`} className={`group relative block overflow-hidden ${tall ? "min-h-[420px] lg:min-h-[520px]" : "min-h-[340px]"}`}>
      <img src={p.images[0]} alt={p.name} loading="lazy" className="img-zoom absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/50 to-black/10" />
      <div className="absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-t from-black/70 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 p-5 sm:p-6 text-[#FDFBF7] [text-shadow:0_1px_3px_rgba(0,0,0,0.8)]">
        <p className="eyebrow text-[#E5D9C5]">{p.city}, {p.state}</p>
        {p.tagline && <p className="mt-2 font-['Cormorant_Garamond'] italic text-lg sm:text-xl text-[#E5D9C5]" data-testid={`property-tagline-${p.slug}`}>“{p.tagline}”</p>}
        <h3 className="text-2xl sm:text-3xl font-semibold mt-1 leading-tight">{p.name}</h3>
        <div className="mt-3 flex items-center justify-between text-sm">
          <span className="font-semibold bg-black/45 backdrop-blur-sm px-3 py-1.5 [text-shadow:none]" data-testid={`property-price-${p.slug}`}>{p.from_price ? `From ${inr(p.from_price)} / night` : p.listed_from_price ? `From ${inr(p.listed_from_price)} / night*` : "Rates on request"}</span>
          <ArrowUpRight size={18} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
        </div>
      </div>
    </Link>
  );
}
